import { render, staticRenderFns } from "./QuestionExamManage.vue?vue&type=template&id=36523360&scoped=true&"
import script from "./QuestionExamManage.vue?vue&type=script&lang=js&"
export * from "./QuestionExamManage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExamManage.vue?vue&type=style&index=0&id=36523360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36523360",
  null
  
)

export default component.exports